// hooks

//

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {

  return (
    <img
        src="/icon_new/my_profile_v2.svg"
        alt="ingro energy logo"
        style={{
          height: "45px",
          width:"45px",
          padding:"2.5px",
          marginRight:"10px",
          marginLeft: "10px",
          display: "inline-block",
          borderRadius: "25px"
        }}
      />

    // <MAvatar
    //   // src={user.photoURL}
    //   // alt={user.displayName}
    //   // color={user.photoURL ? 'default' : createAvatar(user.displayName).color}
    //   {...other}
    // >
    //   {/* {createAvatar(user.displayName).name} */}
    // </MAvatar>
  );
}
